<template>
    <div v-if="params.data" class="flex gap-2">
        <div v-if="attachments.length" class="flex gap-1">
            <div
                v-for="(attUuid, index) in attachments"
                :key="attUuid"
                class="hover:bg-primary/50 border-base-200 shadow rounded flex items-center px-0.5"
                :class="[
                    attUuid === selectedDocumentMetaUuid ? 'bg-primary/50' : 'bg-primary/20',
                    isHoverToOpenDocumentPreviewModal ? 'cursor-zoom-in' : 'cursor-pointer'
                ]"
                @click="onClickDocumentLink(attUuid)"
                @mouseover="onHoverDocumentLink(attUuid)"
            >
                <i class="i-ph-file-magnifying-glass text-xl"/><span class="truncate">{{ attachments.length > 1 ? (index + 1) : '' }}</span>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">

import {TransactionLine} from '@/types/transaction/TransactionLine'
import {computed, provide, ref, watch} from 'vue'
import {getTransactionByUuid} from '@/transaction/transaction.service'
import {useDocumentPreviewModalService} from '@/transaction-journal/DocumentPreview.modal.service'

const {onClickDocumentLink, onHoverDocumentLink, isHoverToOpenDocumentPreviewModal, selectedDocumentMetaUuid} = useDocumentPreviewModalService()
const props = defineProps({
    params: {
        type: Object as () => {
            data: TransactionLine,
            context: any
        },
        required: true
    }
})

provide('panelId', props.params.context.panelId)
provide('panelPathSegment', props.params.context.panelPathSegment)

const attachments = ref<string[]>([])


const transactionLine = computed(() => {
    return props.params.data
})


const transactionUuid = computed(() => {
    return transactionLine.value?.transactionUuid
})

watch(transactionUuid, async () => {
    if (transactionUuid.value) {
        const t = await getTransactionByUuid(transactionUuid.value)
        if (!t) {
            attachments.value = []
            return
        }
        attachments.value = t.documentMetaUuids

    }
}, {immediate: true})

</script>

<style scoped>

</style>